module.exports = __webpack_public_path__ + "img/gntech_gallery3.c1ffd87b.jpg";